import axios from 'axios';
import apiConfig from '../../api.config';

export default function loginRequest(email, password, lang = 'es') {
  const {
    host,
    URIs: { auth },
  } = apiConfig;

  const uri = `${host}${auth.login}`;

  return axios
    .post(uri, JSON.stringify({ email, password, lang }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
